import { createAsyncThunk } from "@reduxjs/toolkit";
import { authGetMeService, authPermissionsService } from "services";
import { AuthPermissionsRequest } from "services/Auth/types";

export const fetchingUserSessionAction = createAsyncThunk(
  "auth/fetchingUserSession",
  async () => {
    const getMeRes = await authGetMeService();
    return getMeRes?.data;
  }
);

export const initUserSessionAction = createAsyncThunk(
  "auth/initUserSession",
  async () => {
    const getMeRes = await authGetMeService();
    return getMeRes?.data;
  }
);

export const refetchUserPermissionsAction = createAsyncThunk(
  "auth/refetchUserPermissions",
  async (params?: AuthPermissionsRequest) => {
    const res = await authPermissionsService(params);
    const applications = res?.data || [];
    const permissions = applications.reduce((prev: Array<string>, next) => {
      return [
        ...prev,
        ...next.access.reduce((cPrev: Array<string>, cNext) => {
          return [...cPrev, ...cNext.permissions];
        }, []),
      ];
    }, []);

    return {
      applications,
      permissions,
    };
  }
);
